// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"uM-z","loadingMedia":"vM-z","reviewsImagesAndVideos":"wM-z","limitHeight":"xM-z"};